import { useNavigate } from 'react-router-dom';

import {
  operadoraFormSchema,
  ROUTER_PATHS,
  useCheckPermissionsArray,
} from '@/shared';
import {
  useCreateOperadora,
  useUpdateOperadora,
} from '@/shared/actions/erp';
import {
  CustomTextField,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import {
  AlertSeverityEnum,
  CreateOperadoraParams,
  Operadora,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { SAVE_OPERADORA_PERMISSIONS } from '../../constants';

export interface SaveOperadoraComponentProps {
  title: string;
  operadora?: Operadora;
}

type SaveFormData = CreateOperadoraParams & {
};

const SaveOperadoraComponent: React.FC<SaveOperadoraComponentProps> = ({ title, operadora }) => {
  useCheckPermissionsArray(SAVE_OPERADORA_PERMISSIONS);

  const returnUrlOperadoraPage = ROUTER_PATHS.configuracionRED.operadoraNav;
  const navigate = useNavigate();

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(operadoraFormSchema),
    defaultValues: {
      estado:true,
    }
  });

  const {
    handleSubmit,
    formState: { errors },
    reset,
  } = form;


  ///* store
  const setAlert = useUiStore(s => s.setAlert);

  ///* mutations
  const createOperadora = useCreateOperadora({
    navigate,
    returnUrl: returnUrlOperadoraPage,
  });
  const updateOperadora = useUpdateOperadora({
    navigate,
    returnUrl: returnUrlOperadoraPage,
  });


  useEffect(() => {

    if (!operadora) return;

    reset(operadora)

    return () => {

    }
  }, [operadora])


  ///* handlers
  const onSave = async (data: SaveFormData) => {

    ///* update
    if (operadora) {
      await updateOperadora.mutateAsync({
        id: operadora.id_operadora!,
        data: {
          ...data,
        },
      });
      return;
    }

    ///* create
    await createOperadora.mutateAsync(data);
  };



  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlOperadoraPage)}
      onSave={handleSubmit(onSave, (errors) => {
        setAlert(true, 'Campos sin llenar', AlertSeverityEnum.error)
        console.log('errors', errors);
      })}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre}
        error={errors.nombre}
        helperText={errors.nombre?.message}
      />
  
    </SingleFormBoxScene>
  );
};

export default SaveOperadoraComponent;
